import {
  REGEX_KATAKANA,
  REGEX_PASSWORD,
  REGEX_PHONE_NUMBER,
} from "constants/common.constant";
import i18n from "i18n";
import * as yup from "yup";

export const schemaValidate = yup.object().shape({
  userName: yup.string().trim().required(i18n.t("login.userId-required")),
  email: yup
    .string()
    .trim()
    .required(i18n.t("input-form.email-required"))
    .email(i18n.t("input-form.invalid-email")),
  password: yup
    .string()
    .trim()
    .required(i18n.t("login.password-required"))
    .matches(
      REGEX_PASSWORD,
      "パスワードは8桁以上・数字・大文字・小文字と記号を含めて入力してください。",
    ),
  passwordConfirm: yup
    .string()
    .trim()
    .required("パスワードを再度入力してください。"),
  firstName: yup.string().trim().required(i18n.t("login.firstName-required")),
  lastName: yup.string().trim().required(i18n.t("login.lastName-required")),
  firstName_yomi: yup
    .string()
    .trim()
    .required(i18n.t("login.firstName-yomi-required"))
    .matches(REGEX_KATAKANA, "名字ーフリガナはカタカナで入力してください。"),
  lastName_yomi: yup
    .string()
    .trim()
    .required(i18n.t("login.lastName-yomi-required"))
    .matches(REGEX_KATAKANA, "名前ーフリガナはカタカナで入力してください。"),
  phoneNumber: yup
    .string()
    .trim()
    .required(i18n.t("supplier-screen.telephone-required"))
    .matches(REGEX_PHONE_NUMBER, "電話番号を正しく入力してください。"),
  role: yup.string().trim().required(i18n.t("login.role-required")),
  org: yup.string().trim().required(i18n.t("login.org-required")),
});
